import React from 'react';
import "./GasResultComponent.css";
import NumberFormat from 'react-number-format';

class GasResultComponent extends React.Component{
    render(){
        const {result_cost} = this.props;
        const {result_per} = this.props;
        if(result_cost > 0 || result_cost === ""){
            return(
                <div>
                    <div className="div_result">
                        <p>고객님께서 도시가스로 연료전환 시</p>
                        <p>연간 <span className="cost_decrease"><NumberFormat value={result_cost} displayType={'text'} thousandSeparator={true}/></span> 만원 (<span className="cost_decrease">{result_per}</span>)%</p>
                        <p>에너지 비용을 <span className="cost_decrease">절감</span>할 수 있습니다</p>
                    </div>
                    <div className="div_question">
                        <p>※ 연료전환 문의 : (주)대륜이엔에스 기술영업 ☎ 031-951-0016~18</p>
                    </div>
                    <div className="div_caution">
                        <p>※ LPG의 경우, 사용하는 기화기의 종류에 따라 기화비용이 추가로 발생될 수 있음</p>
                        <p>※ 위 사항은 연료별 열량을 고려한 계산 결과이며, 연료 사용 환경, 연소기 현황 등에 따라 실제 결과는 달라질 수 있습니다.<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;연료별 에너지열량 환산 기준은 에너지법 시행규칙 별표(2017.12.28 개정)에 따름</p>
                    </div>
                </div>
            )
        }else{
            return(
                <div>
                    <div className="div_result">
                        <p>고객님께서 도시가스로 연료전환 시</p>
                        <p>연간 <span className="cost_increase"><NumberFormat value={(result_cost*-1)} displayType={'text'} thousandSeparator={true}/></span> 만원 (<span className="cost_increase">{result_per*-1}</span>)%</p>
                        <p>에너지 비용이 <span className="cost_increase">추가 발생</span>할 수 있습니다</p>
                    </div>
                    <div className="div_question">
                        <p>※ 연료전환 문의 : (주)대륜이엔에스 기술영업 ☎ 031-951-0016~18</p>
                    </div>
                    <div className="div_caution">
                        <p>※ LPG의 경우, 사용하는 기화기의 종류에 따라 기화비용이 추가로 발생될 수 있음</p>
                        <p>※ 위 사항은 연료별 열량을 고려한 계산 결과이며, 연료 사용 환경, 연소기 현황 등에 따라 실제 결과는 달라질 수 있습니다.<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;연료별 에너지열량 환산 기준은 에너지법 시행규칙 별표(2017.12.28 개정)에 따름</p>
                    </div>
                </div>
            );
        }
    }
}

export default GasResultComponent;